<template>
  <section class="content-width">
    <h2>Rates</h2>

    <p>
      Pricing will vary depending on project details. If you prefer, I can provide a fixed price estimate for your project.
    </p>

    <div class="rate">
      <h3>Software Development</h3>
      <div class="price">$70 / hour</div>
    </div>

    <div class="rate">
      <h3>Other Services</h3>
      <p>
        If you have a use for any of my other <a href="/skills">skills</a>, such as photography or video editing, please <a href="mailto:hello@drey.works">contact me</a> directly.
      </p>
    </div>

    <p>
      Are you a nonprofit? I may be able to offer my services at a discounted rate or, in some situations, for free. Feel free to <a href="mailto:hello@drey.works">contact me</a>!
    </p>

    <p><em>I reserve the right to refuse any business at my own discretion.</em></p>
  </section>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.rate {
  margin: 0 0 36px;
}

.price {
  font-size: 18px;
  font-weight: bold;
}
</style>
